import React, { useState } from "react";
import DeathSquadIcon from "../common/Icons/DeathSquadIcon";
import CyberClashIcon from "../common/Icons/CyberClashIcon";
import KitchenPanicIcon from "../common/Icons/KitchenPanicIcon";
import GameCardDesktop from "./GameCardDesktop";
import { deathSquad, kitchenPanic, cyberClash } from "../../assets/images";

const MobileContentAccordion: React.FC = () => {
  const [accordionStates, setAccordionStates] = useState<boolean[]>([false, false, false]);

  const toggleAccordion = (index: number) => {
    setAccordionStates((prevStates) => {
      const newState = prevStates.map((prevState, idx) => (idx === index ? !prevState : false));
      return newState;
    });
  };

  return (
    <>
      <div className="tw-p-[20px]">
        <div className="tw-space-y-4">
          <div className={`tw-rounded-[5px] tw-overflow-hidden`}>
            <button
              className="tw-w-full tw-flex tw-justify-between tw-items-center tw-bg-transparent tw-text-white tw-border-[2px] tw-border-[#C53CFF] tw-py-[15px] tw-px-[20px] tw-rounded-[15px] focus:tw-outline-none"
              onClick={() => toggleAccordion(0)}
            >
              <span className="tw-flex tw-justify-center tw-items-center tw-gap-[26px]">
                <span className="tw-w-[50px] tw-h-[50px] tw-bg-[#C53CFF] tw-rounded-lg tw-flex tw-justify-center tw-items-center">
                  <DeathSquadIcon height={30} width={30} />
                </span>
                <span className="tw-text-[20px] tw-font-bold tw-text-white">Death Squad</span>
              </span>
              <div className="tw-p-[2px] tw-flex tw-justify-between tw-items-center">
                <svg
                  className={`tw-w-5 tw-h-5 tw-transform tw-transition-transform tw-duration-200 ${!accordionStates[0] ? "-tw-rotate-90" : "tw-rotate-0"}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </button>
            {accordionStates[0] && (
              <div className="tw-mt-[10px]">
                <GameCardDesktop
                  title="Death Squad"
                  description={`Team up and survive against the undead horde as they swarm your base. Earn money as you kill zombies to unlock new areas and buy powerful weapons. Can you hold on until the extraction team arrives?
          <br />
          <br />
          On Special Request: Survival Mode - How many waves can you last? Watch out! If you all die you'll be sent back to round 1. Can you beat the record? Conditions Apply (see T&Cs).`}
                  imageUrl={deathSquad as string}
                />
              </div>
            )}
          </div>
          <div className={`tw-rounded-[5px] tw-overflow-hidden`}>
            <button
              className="tw-w-full tw-flex tw-justify-between tw-items-center tw-bg-transparent tw-text-white tw-border-[2px] tw-border-[#9D62FE] tw-py-[15px] tw-px-[20px] tw-rounded-[15px] focus:tw-outline-none"
              onClick={() => toggleAccordion(1)}
            >
              <span className="tw-flex tw-justify-center tw-items-center tw-gap-[26px]">
                <span className="tw-w-[50px] tw-h-[50px] tw-bg-[#9D62FE] tw-rounded-lg tw-flex tw-justify-center tw-items-center">
                  <KitchenPanicIcon height={30} width={30} />
                </span>
                <span className="tw-text-[20px] tw-font-bold tw-text-white">Cyber Clash</span>
              </span>
              <div className="tw-p-[2px] tw-flex tw-justify-between tw-items-center">
                <svg
                  className={`tw-w-5 tw-h-5 tw-transform tw-transition-transform tw-duration-200 ${!accordionStates[1] ? "-tw-rotate-90" : "tw-rotate-0"}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </button>
            {accordionStates[1] && (
              <div className="tw-mt-[10px]">
                <GameCardDesktop
                  title="Cyber Clash"
                  description={`
          Earn the bragging rights against your mates in these Player vs. Player games. Choose* between Free-For-All, Team Deathmatch, Archery, King Of The Hill, or Battle Royale. Played in a virtual 50m x 50m arena, positioning is key to make sure you come out on top of the leaderboard.
          <br />
          <br />
          * majority rules process at the venue.
          `}
                  imageUrl={cyberClash as string}
                />
              </div>
            )}
          </div>
          <div className={`tw-rounded-[5px] tw-overflow-hidden`}>
            <button
              className="tw-w-full tw-flex tw-justify-between tw-items-center tw-bg-transparent tw-text-white tw-border-[2px] tw-border-[#7886FF] tw-py-[15px] tw-px-[20px] tw-rounded-[15px] focus:tw-outline-none"
              onClick={() => toggleAccordion(2)}
            >
              <span className="tw-flex tw-justify-center tw-items-center tw-gap-[26px]">
                <span className="tw-w-[50px] tw-h-[50px] tw-bg-[#7886FF] tw-rounded-lg tw-flex tw-justify-center tw-items-center">
                  <CyberClashIcon height={30} width={30} />
                </span>
                <span className="tw-text-[20px] tw-font-bold tw-text-white">Kitchen Panic</span>
              </span>
              <div className="tw-p-[2px] tw-flex tw-justify-between tw-items-center">
                <svg
                  className={`tw-w-5 tw-h-5 tw-transform tw-transition-transform tw-duration-200 ${!accordionStates[2] ? "-tw-rotate-90" : "tw-rotate-0"}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </button>
            {accordionStates[2] && (
              <div className="tw-mt-[10px]">
                <GameCardDesktop
                  title="Kitchen Panic"
                  description={`
          "Ever wanted to increase your culinary skills? Keep calm under pressure and quickly produce the finest dishes Paris has to offer before the customers run out of patience. Chop, cook, and even throw ingredients at your teammates to get the meals served before the timer runs out!"
          `}
                  imageUrl={kitchenPanic as string}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileContentAccordion;
